import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import Cookies from '../../../common/cookieManager';

const baseQuery = fetchBaseQuery({
    baseUrl: '/',
    prepareHeaders: headers => {
        headers.set('X-XSRF-TOKEN', Cookies.get('XSRF-TOKEN') as string);
        return headers;
    },
});
export default baseQuery;
